<template>
    <v-modal title="Registros de Orden" :show="show" @close="$emit('close', registrosGuardados)" size="xxl" buttonClose="true">
        <ui-spinner v-if="registros == null" ></ui-spinner>
        <template v-else>
            <two-table-drag2 :izquierda="izquierda" :derecha="derecha" @update="(data) => registros = data"></two-table-drag2>
            <template slot="footer">
                <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-sm btn-primary shadow" @click="onClickGuardar" :disabled="loading">Guardar</button>
            </template>
        </template>
    </v-modal>
</template>
<script>
import vModal from '@/components/vModal';
import TwoTableDrag2 from '@/components/TwoTableDrag2';

export default {
    components: {
        vModal,
        TwoTableDrag2
    },
    props: ['show', 'orden'],
    data() {
        return {
            registros: null,
            izquierda: null,
            derecha: null,
            idioma: '',
            loading: false,
            registrosGuardados: false,
        }
    },
    async created() {
        let vm = this;
        let response = await vm.axios.get(`/ordenes/${vm.orden.idOrden}/detalle`);

        let izquierda = response.data.content.izquierda;

        izquierda = izquierda.map(item => {
            item.selected = false;
            return item;
        });

        let derecha = response.data.content.derecha;

        derecha = derecha.map(item => {
            item.selected = false;
            return item;
        });

        let registros = {
            izquierda,
            derecha,
        }

        vm.izquierda = izquierda;
        vm.derecha = derecha;
        vm.registros = registros;
    },
    methods: {
        onClickGuardar() {
            let vm = this;

            let izquierdaRegistros = vm.registros.izquierda;
            let derechaRegistros = vm.registros.derecha;

            vm.loading = true;

            vm.axios.post(`/ordenes/${vm.orden.idOrden}/detalle`, {
                izquierdaRegistros, derechaRegistros
            })
            .then(response => {
                vm.$toast.fire(response.data.message, '', 'success');
                vm.registrosGuardados = true;
                vm.$emit('close', vm.registrosGuardados);
            })
            .finally(() => {
                vm.loading = false;
            });
        }
    }
}
</script>